export const ScreenBreakpoint = {
	SM: 640,
	MD: 768,
	LG: 1024,
	XL: 1280,
	'2XL': 1536,
	'3XL': 1920,
	'4XL': 2560,
};
